import { Button, Dropdown, Form } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa6';

export default function DropdownSelector({
  options,
  selectedOption,
  setSelected,
  multiple = false,
  haveCheckboxes = false,
  onChange = undefined,
  removeMaxWidthFromLabel = false,
  triggerStyle = {},
  contentStyle,
  closeOnSelect = false,
}) {
  const isSelected = (index) => {
    return multiple ? selectedOption.includes(index) : selectedOption === index;
  };

  const handleSelect = (index, event, item) => {
    // Call onChange if provided
    if (typeof onChange === 'function') {
      onChange(event, item, index);
    }

    if (!multiple) {
      setSelected(index);
      return;
    }

    // Deselect if already selected
    if (selectedOption.includes(index)) {
      setSelected(selectedOption.filter((optionIndex) => optionIndex !== index));
    } else {
      // Select new option
      setSelected([...selectedOption, index]);
    }
  };

  const getDropdownLabel = () => {
    if (!multiple) return options[selectedOption];
    if (selectedOption.length === 0) return 'Select Options';
    if (multiple && selectedOption.length)
      return selectedOption.map((index) => options[index]).join(', ');
    return;
  };

  const autoCloseMode = closeOnSelect ? 'inside' : 'outside';

  return (
    <Dropdown autoClose={autoCloseMode} className="w-100">
      {/* Toggle button */}
      <Dropdown.Toggle
        as={Button}
        variant="primary"
        className="w-100 d-flex align-items-center rounded-2 no-caret fusion-theme-dropdown-toggle"
        style={triggerStyle}
      >
        <span
          className={`ms-2 text-truncate ${removeMaxWidthFromLabel ? '' : 'max-w-lg-3xs'}`}
          style={{ maxWidth: removeMaxWidthFromLabel ? 'none' : 170 }}
        >
          {getDropdownLabel()}
        </span>
        <FaChevronDown className="ms-auto me-2" />
      </Dropdown.Toggle>

      {/* Menu */}
      <Dropdown.Menu className="p-1 w-100 fusion-theme-dropdown-menu" style={{ ...contentStyle }}>
        {options.map((item, index) => (
          <Dropdown.Item
            className="rounded-2 fusion-theme-dropdown-item"
            key={index}
            active={index === selectedOption}
            onClick={(event) => handleSelect(index, event, item)}
          >
            {haveCheckboxes || multiple ? (
              <Form.Check
                type="checkbox"
                label={item}
                disabled={true}
                checked={isSelected(index)}
              />
            ) : (
              item
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
